import React from "react";

import {
  Content,
  Grid,
  GridItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  AnnouncementsPanel
} from "apps/school-site/features/announcements";


const AnnouncementsPage = ({
  categorySlug = "ogloszenia",
  title = "Ogłoszenia",
  description =
    "Aktualne ogłoszenia i informacje dla społeczności szkolnej.",
  limit = 12
}) => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Content
                style={{
                  textAlign: "center"
                }}
              >
                <h1>
                  {title}
                </h1>

                {description && (
                  <p>
                    {description}
                  </p>
                )}
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <AnnouncementsPanel
            categorySlug={categorySlug}
            limit={limit}
          />
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default AnnouncementsPage;